<template>
  <ModalDefault header="y"
                modal_id="searchTicketModal"
                size="modal-lg modal-dialog-scrollable"
                style_header=""
                :modal_header="getTranslations('expression_129')"
                footer="y"
                :method="searchTicket"
                icon="bx bx-search mr-1">
    <div class="px-2 py-2 pb-3" slot="body">
      <div>
        <div class="row px-2 d-flex">
          <div class="col-md-4">
            <label :class="start_date_error ? 'text-danger' : ''" class="mb-0">{{ getTranslations('expression_814') }} </label>
            <div class="input-group">
              <input type="date"

                    onfocus="this.showPicker()"
                    onclick="this.showPicker()"
                     v-model="tickets.search_ticket.start_date"
                     :class="start_date_error ? 'text-danger' : ''"
                     class="input_forms form-control">
            </div>
            <span :class="start_date_error ? 'text-danger' : ''" style="font-size: 13px;">{{ start_date_error }}</span>
          </div>

          <div class="col-md-4">
            <label :class="final_date_error ? 'text-danger' : ''" class="mb-0">{{ getTranslations('expression_815') }} </label>
            <div class="input-group">
              <input type="date"

                    onfocus="this.showPicker()"
                    onclick="this.showPicker()"
                     v-model="tickets.search_ticket.final_date"
                     :class="final_date_error ? 'text-danger' : ''"
                     class="input_forms form-control">
            </div>
            <span :class="final_date_error ? 'text-danger' : ''" style="font-size: 13px;" class="">{{ final_date_error }}</span>
          </div>

          <div class="col-md-4">
            <label class="mb-0">{{ getTranslations('expression_816') }} </label>
            <div class="input-group mb-3">
              <select class="input_forms form-control custom-select"
                      v-model="tickets.search_ticket.status_key">
                <option :value="null">{{ getTranslations('expression_817') }}</option>
                <option v-for="status in configs.data.ticket_statuses"
                        :key="status.id"
                        :value="status.id">
                  {{ status.status }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-4">
            <label class="mb-0">{{ getTranslations('expression_193') }} </label>
            <div class="input-group mb-3">
              <input type="text"
                     v-model="tickets.search_ticket.protocol"
                     class="input_forms form-control">
            </div>
          </div>
          <div class="col-md-4">
            <label class="mb-0">{{ getTranslations('expression_818') }} </label>
            <div class="input-group mb-3">
              <input type="text"
                     v-model="tickets.search_ticket.lead_name"
                     class="input_forms form-control">
            </div>
          </div>
          <div class="col-md-4">
            <label class="mb-0">{{ getTranslations('expression_819') }} </label>
            <div class="input-group mb-3" style="padding-top: .1rem">
              <input type="text"
                     v-model="tickets.search_ticket.lead_phone"
                     class="input_forms form-control">
            </div>
          </div>
        </div>
        <div class="row px-2">
          <div class="col">
            <label class="mb-0">{{ getTranslations('expression_4') }} </label>
            <div class="input-group mb-3">
              <select class="input_forms form-control custom-select"
                      v-model="tickets.search_ticket.channel_id">
                <option :value="null">{{ getTranslations('expression_817') }}</option>
                <option v-for="channel in channels.data"
                        :key="channel.id"
                        :value="channel.id">
                  {{ channel.name }}
                </option>
              </select>
            </div>
          </div>
          
          <div v-if="tickets.search_ticket.channel_id > 0" class="col">
            <label class="mb-0">{{ getTranslations('expression_12') }} </label>
            <div class="input-group mb-3">
              <select class="input_forms form-control custom-select"
                      v-model="tickets.search_ticket.department_id">
                <option :value="null">{{ getTranslations('expression_817') }}</option>
                <option v-for="department in getDepartmentsArray('channel_id', tickets.search_ticket.channel_id)"
                        :key="department.id"
                        :value="department.id">
                  {{ department.name }}
                </option>
              </select>
            </div>
          </div>

          <div v-if="tickets.search_ticket.department_id > 0" class="col">
            <div v-if="canSeeOperatorField()" class="">
              <label class="mb-0">{{ getTranslations('expression_48') }} </label>
              <div class="input-group mb-3">
                <select class="input_forms form-control custom-select"
                        v-model="tickets.search_ticket.operator_id">
                  <option :value="null">{{ getTranslations('expression_817') }}</option>
                  <option v-for="operator in getOperatorsArray('department_id', tickets.search_ticket.department_id)"
                          :key="operator.id"
                          :value="operator.id">
                    {{ getUserObject('id', operator.user_id).name }}
                  </option>
                </select>
              </div>
            </div>
        </div>
        </div>

        <!-- <div v-if="tickets.search_ticket.department_id > 0" class="row px-2">
          <div v-if="getOperatorsArray('user_id', me.data.id).length === 0" class="col">
            <label class="mb-0">{{ getTranslations('expression_48') }} </label>
            <div class="input-group mb-3">
              <select class="input_forms form-control custom-select"
                      v-model="tickets.search_ticket.operator_id">
                <option :value="null">{{ getTranslations('expression_817') }}</option>
                <option v-for="operator in getOperatorsArray('department_id', tickets.search_ticket.department_id)"
                        :key="operator.id"
                        :value="operator.id">
                  {{ getUserObject('id', operator.user_id).name }}
                </option>
              </select>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <div slot="footer" class="px-2 py-2 d-flex">
      <div>
          <span @click.prevent="clearSearch"
                class="shadow-sm cursor_pointer animated--grow-in btn-secondary text-white py-2 px-3 mr-2">
            <span class="">{{ getTranslations('expression_810') }}</span>
          </span>
      </div>
      <div>
          <span @click.prevent="searchTicket"
                class="shadow-sm cursor_pointer animated--grow-in btn-primary text-white py-2 px-3">
            <span class="">{{ getTranslations('expression_811') }}</span>
          </span>
      </div>
    </div>
  </ModalDefault>
</template>

<script>
import ModalDefault from "../../components/general/ModalDefault";
import {mapGetters, mapState} from "vuex";
import $ from "jquery";

export default {
  name: "ModalSearchTickets",
  components: {
    ModalDefault,
  },
  data() {
    return {
      start_date_error: '',
      final_date_error: '',
      some_field_with_error: false,
    }
  },
  computed: {
 
    ...mapState(['tickets', 'configs', 'channels', 'sources', 'me']),
    ...mapGetters([
      'getDepartmentsArray',
      'getOperatorsArray',
      'getInterestsArray',
      'getMotivesArray',
      'getUserObject',
    ])
  },
  methods: {
    canSeeOperatorField() {
      const userId = this.me.data.id;
      const roleKey = this.me.data.role_key;
      const departmentId = this.tickets.search_ticket.department_id;

      const isOperatorInDepartment = this.getOperatorsArray('department_id', departmentId)
      .some(op => op.user_id === userId);

      //Admins (SUPORTE) sempre podem ver todos os canais, departamentos e agentes dos mesmo...
      //Admins "" sempre podem ver os operadores dos canais que esse determinado user esta vinculado
      if (roleKey === 2) return true;

      //Supervisores so podem ver se forem operadores no departamento selecionado
      if (roleKey === 1 && isOperatorInDepartment) return true;

      return false;
    },
    clearSearch() {
      this.tickets.search_ticket = {
        status_key: null,
        channel_id: null,
        source_id: null,
        department_id: null,
        operator_id: null,
        funnel_id: null,
        interest_id: null,
        motive_id: null,
        per_page: 10
      }
      // this.searchTicket();
      this.tickets.filter_tickets_active = false
      this.some_field_with_error = false;
      this.start_date_error = '';
      this.final_date_error = '';
    },
    validateFilter() {
      this.some_field_with_error = false;
      this.start_date_error = '';
      this.final_date_error = '';
      let start_date = this.tickets.search_ticket.start_date;
      let final_date = this.tickets.search_ticket.final_date;

      if(['', null, undefined].includes(start_date)) {
        this.some_field_with_error = true;
        this.start_date_error = this.getTranslations('expression_643');
      }
      if(['', null, undefined].includes(final_date)) {
        this.some_field_with_error = true;
        this.final_date_error = this.getTranslations('expression_643');
      }

      if(!['', null, undefined].includes(start_date) && !['', null, undefined].includes(final_date)) {
        let start_date_time = new Date(start_date);
        let final_date_time = new Date(final_date);

        let difference_in_time = final_date_time.getTime() - start_date_time.getTime();
        let difference_in_days = Math.round(difference_in_time / (1000 * 60 * 60 * 24));

        if(difference_in_days > 31) {
          this.some_field_with_error = true;
          this.start_date_error = this.getTranslations('expression_121');
          this.final_date_error = this.getTranslations('expression_121');
        }
      }

      if(!this.some_field_with_error) {
        this.searchTicket();
      }
    },
    searchTicket() {
      // if (this.$route.name === 'ReportsTickets') {
      this.$store.dispatch('startLoading');
      this.$store.dispatch("getTicketsReport", this.tickets.search_ticket)
      this.$store.dispatch('getTicketsInfo', this.tickets.search_ticket)
      this.tickets.filter_tickets_active = true
      $(`#searchTicketModal`).modal('hide')
      // }
    },
  }
}
</script>

<style scoped>
</style>
